import {VerdeState} from './types'
export const state: VerdeState={
    despachoVerde: [],
    despachoCalificado:[]
}